__turbopack_context__.v({
  "content": "client-side-error-module-scss-module__zVTYJa__content",
  "heading": "client-side-error-module-scss-module__zVTYJa__heading",
  "icon": "client-side-error-module-scss-module__zVTYJa__icon",
  "root": "client-side-error-module-scss-module__zVTYJa__root",
  "text": "client-side-error-module-scss-module__zVTYJa__text",
});
